import { __rest } from "tslib";
import React from "react";
import * as S from "./styles";
export var DesktopMenuPromoCard = function DesktopMenuPromoCard(e) {
  var t = e.slug,
      l = e.headline,
      a = e.url,
      r = e.image,
      n = e.label,
      c = e.description,
      o = e.cta,
      s = __rest(e, ["slug", "headline", "url", "image", "label", "description", "cta"]);

  return React.createElement(S.MenuCard, Object.assign({
    "data-testid": t,
    href: a
  }, s), l ? React.createElement(S.ProductCategory, null, l) : null, r ? React.createElement(S.Image, {
    src: null == r ? void 0 : r.src,
    alt: null == r ? void 0 : r.alt
  }) : null, React.createElement(S.Label, null, n), c ? React.createElement(S.Description, {
    dangerouslySetInnerHTML: {
      __html: c
    }
  }) : null, o ? React.createElement(S.CTA, null, o) : null);
};